export const TIKTOK_ADS_TEST_IDS = {
  root: 'tiktok-ads-integration',
  loading: 'tiktok-ads-loading',
  statusAlert: 'tiktok-ads-status-alert',
  environmentChip: 'tiktok-ads-environment-chip',
  connectButton: 'tiktok-ads-connect-button',
  connectionSelect: 'tiktok-ads-connection-select',
  refreshButton: 'tiktok-ads-refresh-button',
  disconnectButton: 'tiktok-ads-disconnect-button',
  advertiserTable: 'tiktok-ads-advertiser-table',
  advertiserRow: (advertiserId: string) => `tiktok-ads-advertiser-row-${advertiserId}`,
  advertiserCheckbox: (advertiserId: string) => `tiktok-ads-advertiser-checkbox-${advertiserId}`,
  selectedCount: 'tiktok-ads-selected-count',
  saveButton: 'tiktok-ads-save-button',
  entityPreviewButton: 'tiktok-ads-entity-preview-button',
  deliveryPreviewButton: 'tiktok-ads-delivery-preview-button',
  previewSummary: 'tiktok-ads-preview-summary',
  entityEvidence: 'tiktok-ads-entity-evidence',
  deliveryEvidence: 'tiktok-ads-delivery-evidence',
  syncButton: 'tiktok-ads-sync-button',
  lastSync: 'tiktok-ads-last-sync',
  error: 'tiktok-ads-error',
} as const;
